import { render, staticRenderFns } from "./delete-account.vue?vue&type=template&id=22e5b60b&scoped=true"
import script from "./delete-account.vue?vue&type=script&lang=ts"
export * from "./delete-account.vue?vue&type=script&lang=ts"
import style0 from "./delete-account.vue?vue&type=style&index=0&id=22e5b60b&lang=scss"
import style1 from "./delete-account.vue?vue&type=style&index=1&id=22e5b60b&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22e5b60b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sandeep/Work/EIOSYS/CONA-CRM/Admin/Cona-Electrical-Admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('22e5b60b')) {
      api.createRecord('22e5b60b', component.options)
    } else {
      api.reload('22e5b60b', component.options)
    }
    module.hot.accept("./delete-account.vue?vue&type=template&id=22e5b60b&scoped=true", function () {
      api.rerender('22e5b60b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/login/delete-account.vue"
export default component.exports